import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ILanguageInfo, LanguageService } from '../../../core/services/language.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-help-doc-search',
  templateUrl: './help-doc-search.component.html',
  styleUrls: ['./help-doc-search.component.css']
})
export class HelpDocSearchComponent implements OnInit {
    public searchTextButtons: FormButton[] = [
        { id: 'erase', icon: 'fa fa-eraser', type: 'danger', onClick: () => this.clear('searchtext') },
        { id: 'search', icon: 'fas fa-search', type: 'primary', onClick: () => this.loadDocuments() }
    ];

    public setting?: Setting;

    public selectListLanguages: ILanguageInfo[] = [];

    public itemsListDocuments: Item[] = [];

    constructor(private datatask: DataTaskService, private language: LanguageService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2619))[0];
    }

    private async loadLanguages() {
        this.selectListLanguages = await this.language.List();
    }

    private async loadDocuments() {
        if (!this.setting) return;

        return this.itemsListDocuments = await this.datatask.Post(2620, this.setting);
    }

    private clear(id: string) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                this.setting.searchtext = '';

                if (this.setting.searchtext === '') this.loadDocuments();
                break;
            default:
                break;
        }
    }

    public searchItems() {
        this.loadDocuments();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'language_id':
                this.loadDocuments();
                break;
            case 'searchtext':
                if (this.setting.searchtext === '') this.loadDocuments();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadLanguages();
        this.loadDocuments();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    language_id: string;
    searchtext: string;
}
